import { useMutation, useQueryClient } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';
import Api from '@/services/api';
import { message } from 'antd';

type DeleteRosaActionPlanResponse = { data: { id: string }; message: string; status: string };

type UpdateRosaActionPlanRequest = {
	organization_id: string;
	company_id: string;
	report_id: string;
	action_plan_id: string;
	category_id: string;
};

async function deleteRosaActionPlan(params: UpdateRosaActionPlanRequest): Promise<DeleteRosaActionPlanResponse> {
	const url = `/ergonomic-tool/rosa/action-plan/${params.report_id}/${params.action_plan_id}`;
	const { data } = await Api.delete<DeleteRosaActionPlanResponse>(url, { params });
	return data;
}

export const useDeleteRosaActionPlan = () => {
	const queryClient = useQueryClient();
	return useMutation<DeleteRosaActionPlanResponse, any, UpdateRosaActionPlanRequest>(
		(payload) => deleteRosaActionPlan(payload),
		{
			onSuccess: () => {
				queryClient.invalidateQueries([]);
				message.success(I18n.get('Action plan deleted successfully'));
			}
		}
	);
};
